/** Supported application brands. */
export const Id = ['bedc', 'carters'] as const;
